import { createSelector } from 'reselect';
import { productDisclosuresSelector } from 'selectors/testTarget/offers/productDisclosures/productDisclosuresSelector';

const showSelector = createSelector(productDisclosuresSelector, productDisclosures => !!productDisclosures.show);

export { showSelector };
